import { render } from "./UomoConfirm.vue?vue&type=template&id=53f56512&ts=true"
import script from "./UomoConfirm.vue?vue&type=script&lang=ts"
export * from "./UomoConfirm.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3516746311/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__